/**
 * EV-288。作業時間（total_hours_spent）を秒の数値にする。
 *
 * 新しい API は数値の秒（記録が無ければ 0）を返す。古い API は、記録があると秒の文字列（"3725.0"）、
 * 記録が無いと 0（作業時間の照会）か null（作業の要約）を返していた。配備の途中（新しい管理画面と
 * 古い API）でも同じ秒として読む。読めない値は 0 とする。
 */
export function totalSeconds(value: number | string | null | undefined): number {
  const seconds = typeof value === 'string' ? Number(value) : value ?? 0;
  return Number.isFinite(seconds) ? seconds : 0;
}

/**
 * EV-299（2026-10-12 PM 判断: 時・分・秒にそろえる）。秒を時・分・秒に分ける（秒未満は切り捨て）。
 * 作業マスタの削除の要約と、配送先から作業を外す確認が同じ分け方を使う。以前は要約だけが分を
 * 切り上げ、同じ 3725 秒が「1時間 3分」と「1時間 2分 5秒」に分かれていた。
 */
export function secondsToHMS(value: number): { hours: number; minutes: number; seconds: number } {
  const whole = Math.max(0, Math.floor(value));
  return {
    hours: Math.floor(whole / 3600),
    minutes: Math.floor((whole % 3600) / 60),
    seconds: whole % 60,
  };
}
